import { render, staticRenderFns } from "./VacancyInfoCard.vue?vue&type=template&id=7a58a43d&scoped=true&"
import script from "./VacancyInfoCard.vue?vue&type=script&lang=ts&"
export * from "./VacancyInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./VacancyInfoCard.vue?vue&type=style&index=0&id=7a58a43d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a58a43d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VDivider,VIcon,VImg})
